import { useEffect } from 'react';

export default function MissionVision() {
  useEffect(() => {
    const initAOS = async () => {
      try {
        const AOS = (await import('https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js')).default;
        if (AOS && typeof AOS.init === 'function') {
          AOS.init({ 
            duration: 800,
            once: true,
            easing: 'ease-out-cubic'
          });
        }
      } catch (error) {
        console.log('AOS loading skipped');
      }
    };
    initAOS();
    
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css';
    document.head.appendChild(link);
  }, []);

  return (
    <section className="w-full flex justify-center py-16 px-2 max-w-5xl mx-auto">
      <div className="text-justify max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-10 relative">

       
        {/* Mission */}
        <div className="bg-gray-100  rounded-xl p-10 relative z-10" data-aos="fade-right" data-aos-delay="100">
          <h2 className="text-3xl text-center sm:text-4xl md:text-3xl lg:text-4xl font-extralight text-gray-800 mb-4">
            <span
              className="font-bold text-transparent bg-clip-text"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, rgba(109,12,34,1) 0%, rgba(14,56,107,1) 76%)",
              }}
            >
              Mission
            </span>
          </h2>

          <p className="text-gray-900 leading-1 text-sm">
            TBIDO empowers aspiring entrepreneurs and innovators through comprehensive
            incubation services, strategic partnerships, and technology-driven support.
            We are committed to nurturing startups, advancing research commercialization,
            and fostering a culture of innovation that addresses real-world challenges.
          </p>
        </div>

        {/* Vision */}
        <div className="bg-gray-100  rounded-xl p-10 relative z-10" data-aos="fade-left" data-aos-delay="200">
          <h2 className="text-3xl text-center sm:text-4xl md:text-3xl lg:text-4xl font-extralight text-gray-800 mb-4">
            <span
              className="font-bold text-transparent bg-clip-text"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, rgba(109,12,34,1) 0%, rgba(14,56,107,1) 76%)",
              }}
            >
              Vision
            </span>
          </h2>

          <p className="text-gray-900 leading-1 text-sm">
            To be a leading catalyst for innovation and inclusive economic growth by
            building a dynamic startup ecosystem that transforms ideas into impactful,
            sustainable enterprises.
          </p>
        </div>

      </div>
    </section>
  );
}